import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { jwtDecode } from 'jwt-decode';


function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
  e.preventDefault();
  setError('');

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE}/public/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const message = await response.text();
      throw new Error(message || 'Login failed');
    }

    const data = await response.json();
    localStorage.setItem('token', data.token);
 
    // ✅ Decode the token to extract email + userId
    const decoded = jwtDecode(data.token);
    const userEmail = decoded.sub;
    const userId = decoded.userId || decoded.id; // depending on your JWT payload

    login(userEmail, userId);
    navigate('/');
  } catch (err) {
    setError(err.message);
  }
};

  return (
    <div style={{ maxWidth: '400px', margin: '2rem auto', padding: '2rem', border: '1px solid #ccc', borderRadius: '8px' }}>
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <input type="email" placeholder="Email" value={email}
          onChange={(e) => setEmail(e.target.value)}
          required style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem' }}
        />
        <input type="password" placeholder="Password" value={password}
          onChange={(e) => setPassword(e.target.value)}
          required style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem' }}
        />
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit" style={{
          width: '100%', padding: '0.75rem', backgroundColor: '#00796B', color: '#fff',
          border: 'none', borderRadius: '4px', fontWeight: 'bold'
        }}>Login</button>
      </form>
      <p style={{ marginTop: '1rem', textAlign: 'center' }}>
        Don’t have an account? <a href="/register">Register here</a>
      </p>
    </div>
  );
}

export default LoginForm;
